export default {
  widgets: {
    shipmentItems: {
      filters: {
        search: {
          placeholder: 'Поиск...',
        },

        reset: 'Сбросить',
      },
      weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
      months: [
        '',
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
      ],
      selectSlotTime: 'Выберите время отгрузки',
      bronTimeSlot: 'Забранировать время',
      cancel: 'Отмена',
      continue: 'Продолжить',
      noTimeSlots: 'На выбранной дате нету доступных временных слотов',
      showBy: 'Показывать по',
      headers: {
        name: 'Название',
        items: 'Товары',
        status: 'Статус',
        sku: 'SKU',
        ikpu: 'ИКПУ',
        price: 'Цена (сум)',
        price_brutto: 'Цена с НДС',
        quantity: 'На складе',
        inAlifshop: 'В Алифшопе',
      },
      selectedItemsActions: {
        selectAlert: 'Выберите товары, которые хотите отгрузить',
        selectedQuantity: 'Выбрано товаров:',
        allItemsSelected: 'Все товары выбраны',
        clearSelectedItems: 'Сбросить выделенные',
      },
    },
  },
};
